const visitorLogin = {
  msg: {
    mobilePhone: 'Mobile',
    userName: 'Name',
    submit: 'Submit',
    enterMobilePhone: 'Please enter your mobilePhone',
    mobilePhoneMinLength: 'Mobile number must be at least 7 digits',
    enterName: 'Please enter your name',
    switchLang: '中文'
  }
};
export default visitorLogin



// WEBPACK FOOTER //
// ./src/page/visitor/visitorLogin/lang/visitorLogin.en.js